<template>
  <div class="">
    <b-card
      no-body
      class="mr-1"
      style="height: 100%; overflow-x: hidden;"
    >

      <div class="pl-1 pt-1 ">
        <span class="saj-title">
          {{ $t("Search Filter") }}
        </span>
      </div>
      <div class="row align-items-end px-1 mb-1">
        <b-col
          cols="12"
          md="4"
          class="mb-md-0"
        >
          <label class="saj-text">{{ $t("Category") }}:</label>
          <b-form-select
            v-model="selectedCategory"
            :options="categoryList"
            :value="categoryList"
            size="sm"
            class="saj-text"
          />
        </b-col>
        <!-- if admin -->
        <!-- <template v-if="roles.selectedRole === 1"> -->
        <b-col
          v-if="roles.selectedRole === 1"
          cols="12"
          md="4"
          class="mb-md-0"
        >
          <label class="saj-text">{{ $t("Subsidiary") }}:</label>
          <!-- <b-form-select
              v-model="selectedSub"
              :options="subList"
              :value="subList"
              size="sm"
              class="saj-text"
              :disabled="selectedCategory === null"
            /> -->
          <v-select
            v-model="selectedSub"
            class="saj-text select-size-sm"
            style="background: white"
            :placeholder="$t('Choose Subsidiary')"
            :options="subList"
            :reduce="sub => sub.value"
            label="text"
            :clearable="false"
            :disabled="selectedCategory === null"
            @input="roles.selectedRole === 1 && selectedSub !== null ? getData() : ''"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0"
        >
          <label class="saj-text">{{ $t("Work Location") }}:</label>
          <v-select
            v-model="selectedWork"
            class="saj-text select-size-sm"
            style="background: white"
            :placeholder="$t('Choose Work Location')"
            :options="WorkList"
            :reduce="work => work.value"
            label="text"
            :disabled="roles.selectedRole !== 1 ? selectedCategory === null : selectedSub === null"
          />
        </b-col>
        <b-col
          v-if="roles.selectedRole === 1 || roles.selectedRole === 6"
          cols="12"
          md="4"
          class="mb-md-0 pt-1"
        >
          <label class="saj-text">{{ $t("Department") }}:</label>
          <v-select
            v-model="selectedDepartment"
            class="saj-text select-size-sm"
            style="background: white"
            :placeholder="$t('Choose Department')"
            :options="departmentList"
            :reduce="dept => dept.value"
            label="text"
            :disabled="roles.selectedRole !== 1 ? selectedCategory === null : selectedSub === null"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 pt-1"
        >
          <label class="saj-text">{{ $t("Search Name") }}:</label>
          <b-form-input
            id="icons-search"
            v-model="searchname"
            :placeholder="$t('Search name')"
            size="sm"
            :disabled="roles.selectedRole !== 1 ? selectedCategory === null : selectedSub === null"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 pt-1"
        >
          <label class="saj-text">{{ $t("Search Employee Number") }}:</label>
          <b-form-input
            id="icons-search"
            v-model="searchEmpNo"
            :placeholder="$t('Search Employee Number')"
            size="sm"
            :disabled="roles.selectedRole !== 1 ? selectedCategory === null : selectedSub === null"
          />
        </b-col>
        <b-col
          v-if="roles.selectedRole === 1"
          cols="12"
          md="4"
          class="mb-md-0 pt-1"
        >
          <label
            class="saj-text"
          >{{ $t("Year") }}:</label>
          <Datepicker
            id="input-id"
            v-model="selectedCycle"
            :value="customFormatter"
            :format="customFormatter"
            minimum-view="year"
            input-class="year-custom"
            class="show-year-history d-flex"
            :disabled="selectedSub === null"
          />
        </b-col>
        <b-col
          v-if="roles.selectedRole === 6 || roles.selectedRole === 5 || roles.selectedRole === 4 || roles.selectedRole === 3"
          cols="12"
          md="4"
          class="mb-md-0 pt-1"
        >
          <label
            class="saj-text"
          >{{ $t("Year") }}:</label>
          <Datepicker
            id="input-id"
            v-model="selectedCycle"
            :value="customFormatter"
            :format="customFormatter"
            minimum-view="year"
            input-class="year-custom"
            class="show-year-history d-flex"
            :disabled="selectedCategory === null"
          />
        </b-col>
      </div>
      <div
        class="d-flex mt-1 ml-1"
      >
        <div>
          <b-button
            md="4"
            variant="primary"
            class="d-flex justify-content-center mr-1"
            style=""
            :disabled="selectedCategory === null"
            @click="getSummaryReport('search'), currentPage = 1"
          >
            <span class="saj-button d-md-none d-lg-block"> {{ $t("Search") }} </span>
          </b-button>
        </div>
        <div>
          <b-button
            md="4"
            variant="primary"
            class="saj-title d-flex justify-content-center"
            block
            style="
          "
            @click="clearButton()"
          >
            <span class="saj-button d-md-none d-lg-block"> {{ $t("Clear") }}</span>
          </b-button>
        </div>
      </div>
      <!-- <div class="p-1 bg-success" style="width: 500px; overflow: auto;">
            {{ finalData }}
          </div> -->

      <b-overlay
        :show="show"
        rounded="sm"
        class="mt-4"
        style="height: 100%;"
      >

        <template #overlay>
          <div class="d-flex flex-column align-items-center justify-content-center">
            <b-spinner
              variant="primary"
              label="Spinning"
            />
            <p class="mt-1">
              {{ $t('Fetching Data') }}...
            </p>
          </div>

        </template>
        <div
          v-if="showReport"
          class="p-1"
        >
          <b-table
            sticky-header="500px"
            :items="finalData"
            :fields="allColumnField"
            responsive
            bordered
            show-empty
          >

            <template #cell(index)="data">
              <div class="saj-subtitle d-flex justify-content-center">
                {{ currIdx === 1 ? data.index + 1 : (data.index + 1)+((currIdx-1) *perPage) }}
              </div>
              <!-- {{ allColumnField }} -->
            </template>
            <template #thead-top="">
              <b-tr class="saj-subtitle">
                <!--core-->
                <b-th
                  colspan="6"
                  class=""
                >
                  <!-- asdad -->
                </b-th>
                <b-th
                  class="text-center saj-subtitle"
                  style=""
                  variant="primary"
                  :colspan="krajdCol"
                >
                  {{ $t("KRA/JD") }}
                </b-th>
                <b-th
                  class="text-center saj-subtitle"
                  style=""
                  variant="primary"
                  :colspan="core"
                >
                  {{ $t("Competency Core") }}
                </b-th>
                <b-th
                  class="text-center saj-subtitle"
                  style=""
                  variant="primary"
                  :colspan="behaviour"
                >
                  {{ $t("Competency Behaviour") }}
                </b-th>
                <b-th
                  class="text-center saj-subtitle"
                  style=""
                  variant="primary"
                  :colspan="maxSub"
                >
                  {{ $t("Training") }}
                </b-th>
                <b-th
                  class="saj-subtitle"
                  style=""
                  variant="primary"
                  :colspan="additionalCol"
                />
              </b-tr>
            </template>
            <template #head()="data">
              <span
                class="saj-subtitle"
                style=""
              >{{ $t(data.label) }}</span>
            </template>
            <template
              #cell(action)="data"
            >
              <div v-if="roles.selectedRole === 1">
                <feather-icon
                  v-b-tooltip.hover.bottom="$t('Download')"
                  icon="DownloadIcon"
                  size="25"
                  class="hoverIcon ml-1"
                  @click="$bvModal.show('download-pdf'), employeeData = data.item"
                />
              </div>
              <div v-else>
                {{ $t("Not available") }}
              </div>
            </template>
            <template #cell(hod_evaluation)="data">
              <div
                class=""
                style="color: #464e5f; text-align: center"
              >
                <p class="mt-1">
                  {{ data.item.hod_evaluation === null ? '-' : data.item.hod_evaluation }}
                </p>
              </div>
            </template>
            <template #cell(committee_evaluation)="data">
              <div
                class=""
                style="color: #464e5f; text-align: center"
              >
                <p class="mt-1">
                  {{ data.item.final_evaluation }}
                </p>
              </div>
            </template>
            <template #cell(total_score)="data">
              {{ data.item.total_score }}
              <p
                v-b-modal.view-score
                class="mt-1"
                style="text-decoration: underline; color: #5555ff;"
                @click="tempPerf = data.item.performance_id"
              >
                {{ $t("Score Logs") }}
              </p>
            </template>
          </b-table>

          <b-row class="ml-1 mr-1">
            <b-col>
              <span
                class="saj-text"
                align="start"
              >
                {{ $t("Showing") }} {{ from }} {{ $t("to") }} {{ to }} {{ $t("of") }} {{ rows }} {{ $t("entries") }}
              </span>
            </b-col>
            <b-col>
              <div class="d-flex align-items-center justify-content-end">
                <i
                  style="margin-right: 5px"
                  class="fa-solid fa-angles-left saj-page"
                  @click="currentPage = 1, getSummaryReport('search')"
                />
                <i
                  class="fa-solid fa-angle-left saj-page"
                  style=""
                  @click="currentPage !== 1 ? currentPage-- : currentPage === 1, getSummaryReport('search')"
                />
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Page')"
                  :rules="{
                    required,
                    max_value:lastPage,
                    min_value:1,
                  }"
                >
                  <b-form-input
                    v-model="currentPage"
                    class="p-0 text-center"
                    type="number"
                    style="width: 35px; height: 35px; background-color: red; color: white; border-radius: 20px; margin-right: 5px; margin-left: 5px;"
                    @change="currentPage > 0 && currentPage < lastPage + 1 ? getSummaryReport('search'): ''"
                  />
                  <small
                    class="text-danger"
                    style="color: #EA5455 !important;
                            position: absolute;
                            white-space: nowrap;
                            right: 25px;
                          "
                  >{{ errors[0] }}</small>
                </validation-provider>
                <i
                  class="fa-solid fa-angle-right saj-page"
                  style=""
                  @click="currentPage < lastPage ? currentPage++ : currentPage === rows, getSummaryReport('search')"
                />
                <i
                  class="fa-solid fa-angles-right saj-page"
                  style="margin-left: 5px"
                  @click="currentPage = lastPage, getSummaryReport('search')"
                />
              </div>
            </b-col>
          </b-row>

        </div>
        <b-modal
          id="download-pdf"
          :hide-footer="true"
          :hide-header="true"
          :centered="true"
          size="lg"
        >
          <downloadPDF
            :employee-data="employeeData"
            @close="$bvModal.hide('download-pdf')"
          />
        </b-modal>
        <b-modal
          id="view-score"
          :hide-footer="true"
          :hide-header="true"
          :centered="true"
          size="l"
        >
          <viewScore :perf-id="tempPerf" />
        </b-modal>
        <!-- <div
            v-if="showReport"
            class="d-flex justify-content-center mb-2"
          >
            <vue-excel-xlsx
              :data="finalData"
              :columns="columns"
              :file-name="$t('Summary Report')"
              :file-type="'xlsx'"
              :sheet-name="'report'"
              style="border-radius: 5px;
                   background-color: red;
                   border: none;
                   padding-top: 5px;
                   padding-bottom: 5px;"
              class="saj-button"
            >
              {{ $t("EXPORT") }}
            </vue-excel-xlsx>
          </div> -->
      </b-overlay>

    </b-card>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import viewScore from "@/views/pages/summary/view-score.vue"
import {
  BTable, BTr, BTh, BCard,
  BCardHeader,
  // BCardBody,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  VBPopover,
  BPopover,
  BFormInput,
  BOverlay,
  BSpinner,
  //   BModal,
  VBTooltip,
} from 'bootstrap-vue'
import VueExcelXlsx from "vue-excel-xlsx"
import Vue from "vue"
import Ripple from "vue-ripple-directive"
import { mapGetters } from 'vuex'
// import _ from 'lodash'
import SAJToast from "@/component/saj-toastification.vue"
import { ValidationProvider, extend } from 'vee-validate'
import {
  max_value,
  min_value,
} from 'vee-validate/dist/rules'
import { required } from '@validations'
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import downloadPDF from "@/views/pages/summary/summary-report-pdf-modal.vue"
// import AlertModal from '@/pages/alert-modal.vue'

extend('max_value', max_value)
extend('min_value', min_value)

Vue.use(VueExcelXlsx)

export default {
  components: {
    // AlertModal,
    viewScore,
    Datepicker,
    BTable,
    BTh,
    BTr,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BCard,
    // eslint-disable-next-line vue/no-unused-components
    BCardHeader,
    // BCardBody,
    BButton,
    BFormSelect,
    // eslint-disable-next-line vue/no-unused-components
    BPopover,
    BFormInput,
    BOverlay,
    BSpinner,
    ValidationProvider,
    downloadPDF,
    vSelect,
    // BModal,
    // EditEmployee,
    // ApproveEmployee,
    // RevertForm,
    // Template,
  },
  directives: {
    "b-popover": VBPopover,
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {

  },

  data(){
    return {
      selectedCycle: new Date(),
      cycleList: [],
      approvalStatus: [],
      jdkraSetting: null,
      execKRA: null,
      nonExecKRAMain: null,
      nonExecKRASide: null,
      approveList: [],
      tempUser: null,
      performanceId: null,
      tempPerf: null,
      currIdx: null,
      showReport: false,
      allWorkLocation: [],
      isNextData: true,
      show: false,
      additionalCol: 9,
      // maxDariEzra: 6,
      subsidiary_id: null,
      employeeData: null,
      jd_kra_status: null,
      core: 6,
      behaviour: 5,
      maxSub: null,
      apiData: null,
      searchname: null,
      searchEmpNo: null,
      companyID: '',
      selectedCategory: null,
      currentUser: null,
      department_id: null,
      selectedFilter: "",
      selectedWork: null,
      rolesList: [],
      filterList: [],
      allFilter: [],
      allRoles: [],
      allDistrict: [],
      allEmpID: [],
      districtList: [],
      categoryList: [
        { text: `${this.$i18n.t('Choose Category')}`, value: null, disabled: true },
        { text: `${this.$i18n.t('Executive')}`, value: 'Executive' },
        { text: `${this.$i18n.t('Non Executive')}`, value: 'Non Executive' },
      ],
      subList: [],
      selectedSub: null,

      columns: [],

      allColumnField: [
        {
          key: 'index', label: 'No',
        },
        {
          key: 'employee_number', label: 'ID', sortable: true, class: 'text-center', sortDirection: 'desc', thClass: 'custom-header-color', tdClass: "text-capitalize",
        },
        {
          key: 'employee_name', stickyColumn: true, label: 'Name', sortable: true, class: 'text-center', sortDirection: 'desc', thClass: 'custom-header-color', tdClass: "text-capitalize",
        },
        {
          key: 'category', label: 'Category', sortable: true, class: 'text-center', sortDirection: 'desc', thClass: 'custom-header-color', tdClass: "text-capitalize",
        },
        {
          key: 'grade', label: 'Grade', sortable: true, class: 'text-center', sortDirection: 'desc', thClass: 'custom-header-color', tdClass: "text-capitalize",
        },
        {
          key: 'work', label: 'Work Location', sortable: true, class: 'text-center', sortDirection: 'desc', thClass: 'custom-header-color', tdClass: "text-capitalize",
        },

      ],
      finalData: [],
      // currentPageSummaryReport: 0,
      currUserId: null,
      required,
      currentPage: 1,
      perPage: null,
      to: null,
      from: null,
      rows: null,
      lastPage: null,
      kraCol: null,
      krajdCol: 1,
      WorkList: [],
      selectedDepartment: null,
      departmentList: [],
    }
  },
  computed: {
    ...mapGetters(['roles', 'userDetails']),
  },
  watch: {
    // eslint-disable-next-line func-names
    '$i18n.locale': function () {
      this.currentPage = this.currIdx
      // this.getSummaryReport()
      this.categoryList = this.categoryList.map(x => {
        if (x.value === null){
          return {
            ...x,
            text: this.$t('Choose Category'),
          }
        }
        return x
      })
      this.getAllDepartment()
      this.getAllSubsidiary()
    },
  },
  beforeMount() {

  },
  mounted() {
    this.getAllRoles()
    this.getMax()
    this.getAllSubsidiary()
    if (this.roles.selectedRole === 3 || this.roles.selectedRole === 4 || this.roles.selectedRole === 5){
      this.getCurrentUser()
    }
    if (this.roles.selectedRole !== 1){
      this.getWorkLocation()
      this.getAllDepartment()
    }
  },
  methods: {
    getCurrentUser(){
      this.$axios.get(`${this.$baseUrl}/users/current_user`).then(response => {
        this.currentUser = response.data.data.employee.user_id
        this.department_id = response.data.data.employee.department_id
        // console.log("user id", this.currentUser)
        // console.log("dept id", this.department_id)
      })
    },
    clearButton() {
      this.selectedposition = ""
      this.selectedCategory = null
      this.currentPage = 1
      this.finalData = []
      this.selectedSub = null
      this.selectedWork = null
      this.selectedDepartment = null
      this.searchEmpNo = null
      this.searchname = null
      this.selectedCycle = new Date()
      // this.getSummaryReport()
      this.showReport = false
    },
    customFormatter(date) {
      this.scoreYearSelected = moment(date).format('YYYY')
      return this.scoreYearSelected
    },

    getAllRoles() {
      this.$axios.get(`${this.$baseUrl}/roles/getAllRoles`).then(response => {
        this.allRoles = response.data.data

        this.allRoles.forEach(role => {
          this.rolesList.push(role.name)
        })
      })
    },

    getMax() {
      const data = new FormData()
      data.append("subsidiary_id", this.subsidiary_id)
      // console.log("hereeeee", this.userDetails.business_unit)
      this.$axios.get(`${this.$baseUrl}/top_n/get_subsidiary_top_n?subsidiary_id=${this.userDetails.business_unit}`).then(response => {
        this.maxSub = response.data.data[0].top_n
        // console.log('max sub', this.maxSub)
      })
    },

    getKRAMax(search){
      let subs = null

      const params = new URLSearchParams()

      if (this.selectedSub !== null){
        subs = this.selectedSub
      } else {
        subs = this.userDetails.business_unit
      }

      params.append('subsidiary_id', subs)

      this.$axios.get(`${this.$baseUrl}/performance/kra_max`, { params }).then(res => {
        // console.log(res)
        const kraMax = res.data.data[0]

        // console.log('kra max', kraMax.max_kra_executive)

        this.execKRA = kraMax.max_kra_executive
        this.nonExecKRAMain = kraMax.max_main_task
        this.nonExecKRASide = kraMax.max_side_task
        // console.log('get kra max', res)
        this.alterData(search)
      })
    },

    getSetting(){
      let subs = null

      const params = new URLSearchParams()

      if (this.selectedSub !== null){
        subs = this.selectedSub
      } else {
        subs = this.userDetails.business_unit
      }

      params.append('subsidiary_id', subs)

      this.$axios.get(`${this.$baseUrl}/performancesetting/get_multiple_setting_form_jdkra_by_subsidiaries`, { params }).then(res => {
        // const msg = res.data

        this.jdkraSetting = res.data.data[0].jdkra_id

        // console.log('setting', res)
      })
    },

    getSummaryReport(search = 'no') { // filter and get all data
      // console.log('details user: ', this.userDetails)
      this.show = true
      // required parameters : department_id for hod
      // eslint-disable-next-line no-plusplus
      // console.log('user detail', this.userDetails)

      this.getSetting() // determine jd kra

      // this.getKRAMax()

      const params = new URLSearchParams()
      if (this.selectedCategory !== null) {
        params.append('category', this.selectedCategory)
      }
      if (this.selectedSub !== null) {
        params.append('subsidiary_id', this.selectedSub)
      } else if (this.roles.selectedRole === 6) { // if HR
        params.append('subsidiary_id', this.userDetails.business_unit)
      }
      if (this.roles.selectedRole === 3 || this.roles.selectedRole === 4){ // Exec & TM
        params.append('supervisor_id', this.currentUser)
      }
      if (this.roles.selectedRole === 5){
        params.append('department_id', this.department_id)
      }
      if (this.selectedWork !== null) {
        params.append('branch_id', this.selectedWork)
      }
      if (this.selectedDepartment !== null) {
        params.append('department_id', this.selectedDepartment)
      } else if (this.roles.selectedRole === 5) { // if HOD
        params.append('department_id', this.userDetails.department_id)
      }
      if (this.searchname !== null) {
        params.append('employee_name', this.searchname)
      }
      if (this.searchEmpNo !== null){
        params.append('employee_number', this.searchEmpNo)
      }
      params.append('page', this.currentPage)
      params.append('year', moment(this.selectedCycle).year())
      params.append('status', 'active')
      // console.log('hereee', moment(this.selectedCycle).year())
      // params.forEach(a => {
      //   console.log("append", a)
      // })

      // eslint-disable-next-line no-restricted-syntax
      // for (const pair of params.entries()) {
      //   console.log(`${pair[0]}, ${pair[1]}`)
      // }

      this.$axios.post(`${this.$baseUrl}/summary/get_history?subsidiary_id=${this.userDetails.business_unit}`, params).then(response => {
        // console.log('senarai pekerja', response)
        this.showReport = true
        // this.getAllApproveList()
        const summaryReport = response.data.data
        const paging = response.data

        this.from = paging.from
        this.to = paging.to
        this.rows = paging.total
        this.perPage = paging.per_page
        this.lastPage = paging.last_page
        this.currIdx = this.currentPage

        // console.log('summ report', paging)
        if (summaryReport.length === 0) {
          this.isNextData = false
          this.$toast(
            {
              component: SAJToast,
              props: {
                title: `${this.$i18n.t(`No more data`)}.`,
                icon: "CheckCircleIcon",
                variant: "info",
                titleColor: "#000",
              },
            },
            {
              position: "top-right",
              type: 'info',
            },
          )
        }
        this.apiData = summaryReport
        // console.log("hereee", this.apiData)

        this.getKRAMax(search)

        // setTimeout(() => {
        //   // this.show = false
        //   this.alterData(search)
        //   console.log("timeee")
        // }, 2000)

        // this.alterData(search)
        // this.show = false
      }).catch(() => {
        // console.log(error.message)
        this.show = false
      })
    },
    getWorkLocation(){
      let a

      if (this.roles.selectedRole === 1){
        a = this.selectedSub
      } else {
        a = this.userDetails.business_unit
      }
      this.$axios.get(`${this.$baseUrl}/branch/get_branch_by_company?company_id=${a}`).then(res => {
        const work = res.data.data
        this.WorkList = work.map(x => ({
          text: x.name,
          value: x.id,
        }))
      })
    },
    getData(){
      this.getAllDepartment()
      this.getWorkLocation()
      if (this.selectedWork !== null){
        this.selectedWork = null
      }
      if (this.selectedDepartment !== null){
        this.selectedDepartment = null
      }
    },
    getAllSubsidiary() {
      const config = {
        method: 'get',
        url: `${this.$baseUrl}/subsidiary/getAll`,
      }

      this.$axios(config)
        .then(response => {
          this.subList = [{ text: `${this.$i18n.t('Choose Subsidiary')}`, value: null, disabled: true }]
          const result = response.data
          if (result.success) {
            result.data.subsidiaries.forEach(sub => {
              this.subList.push({
                text: sub.subsidiary_name,
                value: sub.id,
              })
            })
          }
        })
        .catch(() => {
          // console.log(error)
        })
    },
    getAllDepartment() {
      let a

      if (this.roles.selectedRole === 1){
        a = this.selectedSub
      } else {
        a = this.userDetails.business_unit
      }
      const config = {
        method: 'get',
        url: `${this.$baseUrl}/departments/get_departments_by_subsidiary?subsidiary_id=${a}`,
      }

      this.$axios(config)
        .then(response => {
          this.departmentList = []
          // this.departmentList.push({
          //   text: 'Choose Department',
          //   value: null,
          //   disabled: true,
          // })
          const result = response.data
          if (result.success) {
            const depts = result.data

            this.departmentList = depts.map(dep => ({
              text: dep.name,
              value: dep.id,
            }))
          }
        })
        .catch(() => {
          // console.log(error)
        })
    },

    alterData(search) {
      const allTrainingScore = []
      if (this.allColumnField.length > 7) {
        this.allColumnField.splice(6, (this.allColumnField.length - 5))
      }
      // console.log('kra col', this.apiData.)
      // console.log(allTrainingScore)
      // eslint-disable-next-line no-plusplus

      if (this.selectedCategory === 'Non Executive'){
        if (this.jdkraSetting === 0){
          allTrainingScore.push({
            key: `jd`,
            label: `${this.$i18n.t(`JD`)}`,
            class: 'text-center',
          })

          this.krajdCol = 1
          // console.log('jd non exec', this.jdkraSetting)
        } else {
          for (let j = 0; j < this.nonExecKRAMain; j += 1) {
            allTrainingScore.push({
              key: `main${j}`,
              label: `${this.$i18n.t(`MAIN`)} ${j + 1}`,
              class: 'text-center',
            })
          }

          for (let j = 0; j < this.nonExecKRASide; j += 1) {
            allTrainingScore.push({
              key: `side${j}`,
              label: `${this.$i18n.t(`SIDE`)} ${j + 1}`,
              class: 'text-center',
            })
          }
          this.krajdCol = this.nonExecKRAMain + this.nonExecKRASide
          // console.log('kra non exec')
        }
      }

      if (this.selectedCategory === 'Executive'){
        for (let j = 0; j < this.execKRA; j += 1) {
          allTrainingScore.push({
            key: `kra${j}`,
            label: `${this.$i18n.t(`KRA`)} ${j + 1}`,
            class: 'text-center',
          })
        }
        this.krajdCol = this.execKRA
        // console.log('kra exec', this.execKRA)
        // console.log('kra exec', allTrainingScore)
      }

      for (let j = 0; j < this.core; j += 1) {
        allTrainingScore.push({
          key: `compentency_core${j}`,
          label: `${this.$i18n.t(`core`)} ${j + 1}`,
          class: 'text-center',
        })
      }
      for (let k = 0; k < this.behaviour; k += 1) {
        allTrainingScore.push({
          key: `competency_behaviour${k}`,
          label: `${this.$i18n.t(`behaviour`)} ${k + 1}`,
          class: 'text-center',
        })
      }
      for (let i = 0; i < this.maxSub; i += 1) {
        allTrainingScore.push({
          key: `training${i}`,
          label: `${this.$i18n.t(`training`)} ${i + 1}`,
          class: 'text-center',
        })
      }

      allTrainingScore.push({
        key: `contribution`,
        label: `Contribution`,
        class: 'text-center',
      })
      allTrainingScore.push({
        key: `total_score`,
        label: `Total Score`,
        sortable: true,
        class: 'text-center',
      })
      allTrainingScore.push({
        key: `performance_grade`,
        label: `Performance Grade`,
        sortable: true,
        class: 'text-center',
      })
      allTrainingScore.push({
        key: `hod_evaluation`,
        label: `HOD Evaluation`,
        sortable: true,
        class: 'text-center',
      })
      if (this.roles.selectedRole === 1 || this.roles.selectedRole === 6){
        allTrainingScore.push({
          key: `committee_evaluation`,
          label: `Committee Evaluation`,
          class: 'text-center',
        })
      }
      allTrainingScore.push({
        key: `comment`,
        label: `Comment`,
        class: 'text-center',
      })
      allTrainingScore.push({
        key: 'appraiser_comment',
        label: 'Supervisor Comment',
        class: 'text-center',
      })
      allTrainingScore.push({
        key: `action`,
        label: `Action`,
        class: 'text-center',
      })
      allTrainingScore.push({
        key: `status`,
        label: `Status`,
        class: 'text-center',
      })
      // console.log('column', this.allColumnField)
      // console.log('training score before splice', allTrainingScore)
      if (this.allColumnField.length < 7) {
        this.allColumnField.splice(7, 0, ...allTrainingScore)
      }

      // console.log('column after splice', this.allColumnField)

      this.columns = []

      this.allColumnField.forEach(a => {
        this.columns.push({
          label: a.label,
          field: a.key,
        })
      })

      // eslint-disable-next-line no-unused-vars
      // this.finalData = []
      if (search === 'search') {
        this.finalData = []
      }

      // console.log('apidata', this.apiData)

      this.apiData.forEach(item => {
        const allTraining = {}

        for (let i = 0; i < this.maxSub; i += 1) {
          const key = `training${i}`
          if (item.training !== null) {
            const tempData = item.training[i]
            allTraining[key] = tempData !== undefined ? tempData.score : 0
          } else {
            allTraining[key] = 0
          }
        }

        if (this.selectedCategory === 'Executive'){
          for (let i = 0; i < this.execKRA; i += 1) {
            const key = `kra${i}`
            if (item.jd_kra_data !== null) {
              const tempData = item.jd_kra_data[i]
              // console.log('kra exec', tempData)
              allTraining[key] = tempData !== undefined ? tempData.score : 0
            } else {
              allTraining[key] = 0
            }
          }
          // console.log('data exec')
        } else if (this.selectedCategory === 'Non Executive'){
          if (this.jdkraSetting === 0){
            // eslint-disable-next-line dot-notation
            allTraining[`jd`] = item.jd_kra_total
          } else {
            for (let i = 0; i < this.nonExecKRAMain; i += 1) {
              const key = `main${i}`
              if (item.jd_kra_data !== null) {
                const tempData = item.jd_kra_data[0]
                // console.log('kenapaaaaa', tempData)
                if (tempData.main_task !== null && tempData.main_task !== undefined){
                  // console.log('main task ini', item.employee_name, tempData.main_task[i])
                  allTraining[key] = tempData.main_task[i] !== undefined ? tempData.main_task[i].score : 0
                } else {
                  // console.log('main task null')
                  allTraining[key] = 0
                }
              } else {
                // console.log('jd kra data tak ada')
                allTraining[key] = 0
              }
              // console.log(item.employee_name, key, 'is', allTraining[key])
            }

            for (let i = 0; i < this.nonExecKRASide; i += 1) {
              const key = `side${i}`
              if (item.jd_kra_data !== null) {
                const tempData = item.jd_kra_data[0]
                if (tempData.side_task !== null && tempData.side_task !== undefined){
                  // console.log('main task ini', item.employee_name, tempData.side_task[i])
                  allTraining[key] = tempData.side_task[i] !== undefined ? tempData.side_task[i].score : 0
                } else {
                  // console.log('main task null')
                  allTraining[key] = 0
                }
              } else {
                // console.log('jd kra data tak ada')
                allTraining[key] = 0
              }
              // console.log(item.employee_name, key, 'is', allTraining[key])
            }
          }
          // console.log('data non exec', item.jd_kra_total)
        }
        // if (item.compentency_core !== null) {
        //   item.compentency_core.forEach((data, index) => {
        //     const key = `compentency_core${index}`
        //     //   [key] = data.score
        //     allTraining[key] = data.score
        //   })
        // }

        for (let i = 0; i < this.core; i += 1) {
          const key = `compentency_core${i}`
          if (item.compentency_core !== null) {
            const tempData = item.compentency_core[i]
            allTraining[key] = tempData !== undefined ? tempData.score : 0
          } else {
            allTraining[key] = 0
          }
        }

        // if (item.competency_behaviour !== null) {
        //   item.competency_behaviour.forEach((data, index) => {
        //     const key = `competency_behaviour${index}`
        //     //   [key] = data.score
        //     allTraining[key] = data.score
        //   })
        // }

        for (let i = 0; i < this.behaviour; i += 1) {
          const key = `competency_behaviour${i}`
          if (item.training !== null) {
            const tempData = item.competency_behaviour[i]
            allTraining[key] = tempData !== undefined ? tempData.score : 0
          } else {
            allTraining[key] = 0
          }
        }

        // console.log('kra data', item.jd_kra_data)

        let isSubmit = false
        let isAgreed = false
        let isApprove = false
        // let isCarryMark = false

        switch (this.roles.selectedRole){
          case 1:
            // Admin
            // isApprove = item.approval_status.approved_hr === 1

            if (item.approval_status.approved_hr === 1){
              if (item.approval_status.approved_shr === 1){
                isApprove = true
              } else {
                isApprove = false
              }
              isSubmit = true
            } else {
              isApprove = false
            }
            // console.log('1')
            break
          case 3:
            // Exec
            // isSubmit = item.approval_status.submit
            // isAgreed = item.approval_status.agree
            if (item.approval_status.submit === 1){
              if (item.approval_status.agree === 1){
                isAgreed = true
                isApprove = true
              } else {
                isApprove = false
              }
              isSubmit = true
            } else {
              // isSubmit = false
              isApprove = false
            }
            // console.log('3')
            break
          case 4:
            // TM
            if (item.approval_status.submit === 1){
              if (item.approval_status.agree === 1){
                // isAgreed = true
                isApprove = true
                isAgreed = true
              } else {
                isApprove = false
              }
              isSubmit = true
            } else {
              // isSubmit = false
              isApprove = false
            }
            // console.log('4')
            break
          case 5:
            // HOD
            if (item.approval_status.agree === 1){
              if (item.approval_status.approved_hod === 1){
                isApprove = true
              } else {
                isApprove = false
              }
              isAgreed = true
            } else {
              isAgreed = false
              isApprove = false
            }
            // console.log('5')
            break
          case 6:
            // HR
            if (item.approval_status.approved_hod === 1){
              if (item.approval_status.approved_hr === 1){
                isApprove = true
              } else {
                isApprove = false
              }
              isSubmit = true
            } else {
              isApprove = false
            }

            // console.log('6')
            break
          default:
            break
        }

        // console.log('job task score', item)

        this.finalData.push(
          {
            performance_id: item.performance_id,
            employee_number: item.employee_number,
            employee_name: item.employee_name,
            user_id: item.user_id,
            category: item.category,
            grade: item.grade,
            work: item.work_location,
            jd_kra_total: item.jd_kra_total,
            contribution: item.contribution.score,
            total_score: item.total_score,
            performance_grade: item.performance_grade === null ? '-' : item.performance_grade,
            final_evaluation: item.final_evaluation === null ? '-' : item.final_evaluation,
            comment: item.comment === null ? '-' : item.comment.comment,
            appraiser_comment: item.appraiser_comment === null || item.appraiser_comment.comment === null ? '-' : item.appraiser_comment.comment,
            approved_at: item.performance_approved_at,
            action: null,
            jd_kra_status: item.jd_kra_status,
            // job_task_score: item.jd_kra_data ? item.jd_kra_data[0].job_task_score : "",
            // job_subtask_score: item.jd_kra_data ? item.jd_kra_data[0].job_subtask_score : "",
            jd_kra_data: item.jd_kra_data,
            status: item.approval_status.message,
            is_submit: isSubmit,
            is_agree: isAgreed,
            is_approve: isApprove,
            approval_status: item.approval_status,
            subsidiary_id: item.subsidiary_id,
            grade_set: item.grade_set,
            department_id: item.department_id,
            role: item.role,
            hod_evaluation: item.hod_evaluation,
            // jd: this.selectedCategory === 'Non Executive' && this.jdkraSetting === 0 ? item.jd_kra_total : null,
            // kra: kraData,

            ...allTraining,
          },
        )
      })
      this.show = false
    },

  },
}
</script>
  <style type="text/css">
      .popover{
          max-width:600px;
      }
  </style>
  <style>
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  :hover::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
  }

  :hover::-webkit-scrollbar-thumb {

    /* background-color: #a0a0a5 !important; */
    background-color: rgb(255, 0, 0)
  }

  ::-webkit-scrollbar-thumb:hover {
    border: 2px solid #bbb9b9 !important;
  }
  .table thead th {
      font-size: 1rem !important;
  }
  .vdp-datepicker * {
      box-sizing: border-box;
      font-size: small;
      text-align: center;
      right: 0px !important;
      top: 10px;
  }
  .vdp-datepicker__calendar {
      top: 30px !important;
  }
  input, select, optgroup, textarea {
      margin: 0;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      height: 2.142rem;
      font-size: 0.857rem;
      border: 1px solid #d8d6de;
      color: #6e6b7b;
      border-radius: 0.357rem;
  }
  /* element.style {
      right: 520px;
      display: none;
  } */
  .show-year-history .vdp-datepicker__calendar {
  left:  0px !important;
  }
  </style>
